'use client';

import { c as _c } from "react/compiler-runtime";
import { useAuth0 } from '@auth0/auth0-react';
import { Button, ButtonProps } from '@petsmart-ui/sparky';
import { usePathname, useSearchParams } from 'next/navigation';
import { ReactElement, useCallback } from 'react';
import { AccountDrawerType } from '../types/pageLayout';
import { getAuth0LoginRedirectOptions, isAuth0RestrictedCheckoutReturnTo } from '../utils/getAuth0LoginRedirectOptions';
import { getAuth0ReturnTo, isSamePageReturnTo } from '../utils/getAuth0ReturnTo';
import { useCart } from './useCart';
import { useDecisions } from './useDecisions';
import { usePageLayout } from './usePageLayout';
type SignInCreateAccountButtonProps = Omit<Exclude<ButtonProps, {
  href: string;
}>, 'href'>;
export function SignInCreateAccountButton(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Button data-testid="signInCreateAccount" text="Sign in / Create account" {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export function useAuthSignInClick(returnTo) {
  const $ = _c(21);
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const {
    openAccountDrawer
  } = usePageLayout();
  const {
    cart
  } = useCart();
  const isAuth0Enabled = useDecisions("auth0");
  const {
    loginWithRedirect
  } = useAuth0();
  let t0;
  if ($[0] !== pathname || $[1] !== searchParams) {
    const search = searchParams?.toString() ?? "";
    t0 = getAuth0ReturnTo({
      pathname,
      search
    });
    $[0] = pathname;
    $[1] = searchParams;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const currentPath = t0;
  const resolvedReturnTo = returnTo ?? currentPath;
  let t1;
  if ($[3] !== resolvedReturnTo || $[4] !== returnTo) {
    t1 = returnTo === undefined && !isSamePageReturnTo(resolvedReturnTo);
    $[3] = resolvedReturnTo;
    $[4] = returnTo;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const returnToIsImplicit = t1;
  let t2;
  if ($[6] !== resolvedReturnTo || $[7] !== returnTo) {
    t2 = returnTo !== undefined && isAuth0RestrictedCheckoutReturnTo(resolvedReturnTo);
    $[6] = resolvedReturnTo;
    $[7] = returnTo;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const includeCartCategoryParams = t2;
  let t3;
  if ($[9] !== cart || $[10] !== currentPath || $[11] !== includeCartCategoryParams || $[12] !== isAuth0Enabled || $[13] !== loginWithRedirect || $[14] !== openAccountDrawer || $[15] !== resolvedReturnTo || $[16] !== returnToIsImplicit) {
    t3 = () => {
      if (isAuth0Enabled) {
        return void loginWithRedirect(getAuth0LoginRedirectOptions({
          returnTo: resolvedReturnTo,
          returnToIsImplicit,
          cart: includeCartCategoryParams ? cart : undefined,
          flowEntry: currentPath
        }));
      }
      openAccountDrawer(AccountDrawerType.SIGN_IN);
    };
    $[9] = cart;
    $[10] = currentPath;
    $[11] = includeCartCategoryParams;
    $[12] = isAuth0Enabled;
    $[13] = loginWithRedirect;
    $[14] = openAccountDrawer;
    $[15] = resolvedReturnTo;
    $[16] = returnToIsImplicit;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  const handleSignInClick = t3;
  let t4;
  if ($[18] !== handleSignInClick || $[19] !== isAuth0Enabled) {
    t4 = {
      isAuth0Enabled,
      handleSignInClick
    };
    $[18] = handleSignInClick;
    $[19] = isAuth0Enabled;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  return t4;
}